<form>
  <div class="modal-header">
    <h4 class="modal-title">{{ pageTitle }}</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="activeModal.dismiss('')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-group">
      <div class="input-group mb-3">
        <ng-select
          [items]="purchaseOrdersList"
          [addTag]="false"
          [multiple]="true"
          [hideSelected]="true"
          [loading]="purchaseOrderLoading"
          [typeahead]="purchaseOrderInput$"
          (add)="getPOItems($event)"
          bindValue="id"
          (remove)="onRemove($event, rrItemSource.PURCHASE_ORDER)"
          name="po_number"
          placeholder="Search PO number, or SKU, or Alternate SKU"
          (clear)="clearItems(rrItemSource.PURCHASE_ORDER)"
        >
          <ng-template ng-label-tmp let-item="item" let-clear="clear">
            <span
              class="ng-value-icon right"
              (click)="clear(item)"
              aria-hidden="true"
              >×</span
            >
            <span>
              [{{ item.id | purchaseOrderFormat }}]
              {{ item | purchaseOrderDisplayFormat }}
            </span>
          </ng-template>
          <ng-template
            ng-option-tmp
            let-item="item"
            let-index="index"
            let-search="searchTerm"
          >
            <h6>
              [{{ item.id | purchaseOrderFormat }}]
              {{ item | purchaseOrderDisplayFormat }}
            </h6>
          </ng-template>
        </ng-select>
      </div>
    </div>

    <div class="form-group">
      <div class="input-group mb-3">
        <ng-select
          [items]="shipments$ | async"
          [addTag]="false"
          [multiple]="true"
          [hideSelected]="true"
          [loading]="shipmentsLoading"
          [typeahead]="shipmentsInput$"
          (add)="getShipmentItems($event)"
          bindValue="id"
          (remove)="onRemove($event, rrItemSource.SHIPMENT)"
          name="po_number"
          placeholder="Search by shipment status name, key/value"
          (clear)="clearItems(rrItemSource.SHIPMENT)"
        >
          <ng-template ng-label-tmp let-item="item" let-clear="clear">
            <span
              class="ng-value-icon right"
              (click)="clear(item)"
              aria-hidden="true"
              >×</span
            >
            <span>
              [{{ item?.id }}] {{ item?.purchaseOrder?.factory?.factoryName }} -
              {{ item?.purchaseOrder?.id }}
            </span>
          </ng-template>
          <ng-template
            ng-option-tmp
            let-item="item"
            let-index="index"
            let-search="searchTerm"
          >
            <h6>
              [{{ item?.id }}] {{ item?.purchaseOrder?.factory?.factoryName }} -
              {{ item?.purchaseOrder?.id }}
            </h6>
          </ng-template>
        </ng-select>
      </div>
    </div>

    <table class="table">
      <thead>
        <tr>
          <th *ngIf="rrItems?.length > 0">
            <mat-checkbox
              color="primary"
              [(ngModel)]="checkedAll"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="checkAll()"
            >
            </mat-checkbox>
          </th>
          <th>&nbsp;</th>
          <th>ID</th>
          <th>SKU</th>
          <th width="200">Product Name</th>
          <th>Warehouse</th>
          <th *ngIf="itemLocationsEnabled">Location</th>
          <th *ngIf="ftLocationBins && ftLotTracking">Lot</th>
          <th>Qty</th>
          <th>Unit</th>
          <th>Unit Price</th>
          <th>Line Total</th>
          <th>Apply Tag</th>
          <th>&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let item of rrItems; let i = index"
          [ngClass]="{
            'table-danger': item.rfq.status === productStatus.DELETED,
          }"
        >
          <td *ngIf="rrItems?.length > 0">
            <mat-checkbox
              color="primary"
              [(ngModel)]="checked[i]"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="countChecked()"
            >
            </mat-checkbox>
          </td>
          <td>
            <a
              href="javascript:;"
              class="duplicate text-info"
              (click)="duplicateRow(item, i)"
            >
              <i class="fas fa-copy"></i>
            </a>
          </td>
          <td>{{ item.purchase_order_id | purchaseOrderFormat }}</td>
          <td class="text-nowrap">{{ item.internal_sku || 'N/A' }}</td>
          <td>
            {{ item.product_name }}
          </td>
          <td>
            <lum-warehouse-search-dropdown
              [selected]="item.warehouse"
              (selectItemEvent)="onSelectWarehouse($event, i)"
            ></lum-warehouse-search-dropdown>
            <!-- <select
              class="form-control"
              name="wh{{ i + 1 }}"
              [(ngModel)]="item.warehouse_id"
              (change)="onWarehouseChange(i)"
            >
              <option *ngFor="let w of warehouses" [value]="w.id">
                {{ w.location_name }}
              </option>
            </select> -->
          </td>
          <td *ngIf="itemLocationsEnabled">
            <lum-warehouse-search-dropdown
              [selected]="item.location"
              [warehouseId]="item.warehouse_id"
              [disabled]="item.warehouse ? false : true"
              (selectItemEvent)="onSelectLocation($event, i)"
            ></lum-warehouse-search-dropdown>
            <!-- <ng-select
              [items]="locations | filterById: { parent_id: item.warehouse_id }"
              bindValue="id"
              bindLabel="location_name"
              (ngModelChange)="loadWarehouseLocations(i)"
              [loading]="item.loading"
              [(ngModel)]="item.location_id"
              [ngModelOptions]="{ standalone: true }"
              [clearable]="false"
            ></ng-select> -->
          </td>
          <td
            *ngIf="enabledBinLocationAndLotTracking(item.rfq)"
            class="flex-container"
          >
            <lum-rfq-lot-search-dropdown
              [rfqId]="item.rfq_id"
              [selected]="item.lot"
              (selectLotEvent)="onSelectLot($event, i)"
              (createNewLotEvent)="onOpenCreateLotDialog(item, i)"
            ></lum-rfq-lot-search-dropdown>
            <!-- <ng-select
              [items]="rfqLots | filterById: { rfq_id: item.rfq_id }"
              bindValue="id"
              bindLabel="lot_number"
              (ngModelChange)="loadWarehouseLocations(i)"
              [loading]="item.loading"
              [(ngModel)]="item.lot_id"
              [ngModelOptions]="{ standalone: true }"
              [clearable]="false"
              class="min-width-lot"
            >
              <ng-template ng-footer-tmp>
                <p class="create-new" (click)="createNewLot(item, i)">Create a new Lot</p>
              </ng-template>
            </ng-select> -->
          </td>
          <td
            *ngIf="ftLotTracking && !enabledBinLocationAndLotTracking(item.rfq)"
            class="flex-container"
          ></td>
          <td>
            <input
              type="number"
              class="form-control text-right min-width-qty"
              name="qty{{ i + 1 }}"
              [(ngModel)]="item.quantity"
              (change)="computeLineTotal(i)"
              lumDecimalLimit
            />
          </td>
          <td class="valign-td">
            <span *ngIf="item.received_uom_id">
              {{ getUomName(item.rfq_id, item.received_uom_id) }}
            </span>
          </td>
          <td>
            <input
              type="number"
              class="form-control text-right min-width-price"
              name="price{{ i + 1 }}"
              [(ngModel)]="item.unit_price"
              (change)="computeLineTotal(i)"
            />
          </td>
          <td>
            <input
              type="number"
              class="form-control text-right min-width-price"
              name="total{{ i + 1 }}"
              [value]="item.line_total | decimalPlaces"
              lumDecimalLimit
            />
          </td>
          <td>
            <ng-select
              [items]="tags"
              [searchFn]="customTagsSearchFn"
              bindValue="id"
              multiple="true"
              [(ngModel)]="item.tag_ids"
              name="tags{{ i + 1 }}"
            >
              <ng-template ng-label-tmp let-item="item" let-clear="clear">
                <span
                  class="ng-value-icon right"
                  (click)="clear(item)"
                  aria-hidden="true"
                  >×</span
                >
                <span [innerHTML]="item.name" class="d-inline"></span>
              </ng-template>
              <ng-template
                ng-option-tmp
                let-item="item"
                let-index="index"
                let-search="searchTerm"
              >
                <h6 [innerHTML]="item.name"></h6>
              </ng-template>
            </ng-select>
          </td>
          <td>
            <a href="javascript:;" (click)="rrItems.splice(i, 1)">
              <i class="fas fa-times text-danger"></i>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="modal-footer">
    <div class="table-actions">
      <button
        [matMenuTriggerFor]="tableSelectionMenu"
        *ngIf="checkedCount > 0"
        class="btn btn-primary mr-2"
      >
        {{ this.checkedCount }} Selected POs <caret></caret>
      </button>
      <mat-menu #tableSelectionMenu="matMenu">
        <button mat-menu-item (click)="addBulkTags()">Bulk Add Tags</button>
        <button
          *ngFeatureFlag="featureFlag.UNIQUE_LOT_NUMBER_PER_SKU; isDisabled: false"
          mat-menu-item
          (click)="bulkCreateLot()"
        >
          Bulk Update Lot
        </button>
      </mat-menu>
    </div>
    <button
      type="button"
      class="btn btn-outline-secondary"
      (click)="activeModal.dismiss('')"
      [disabled]="loading"
      [translate]="'BUTTONS.CLOSE'"
    >
      <i class="fas fa-times"></i> Close
    </button>
    <button (click)="addItems()" type="button" class="btn btn-primary">
      <i class="fas fa-check"></i> Add Items
    </button>
  </div>
</form>
